import {freeze, height, error} from 'methods/utils';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import Layout from 'components/layout';

Swiper.use([Navigation, Pagination]);

function HotelMenuNavigation() {
    // менюшка навигации по странице
    this._initNavMenu = function() {
        const customOffset = 30;
        let menuOffset = customOffset;
        document.querySelectorAll('.js-menuOffset').forEach($item => menuOffset += height($item));

        if (this._menuBlockIntervalId) {
            clearInterval(this._menuBlockIntervalId);
            this._menuBlockIntervalId = null;
        }

        this._$menu     = document.querySelector('.js-mainNav');
        this._$menuList = this._$menu.querySelector('.js-menuList');
        this._$header   = document.querySelector('.js-header');

        let $menuSwiper = document.querySelector('.js-menuSwiper');
        if (!$menuSwiper) {
            return error('.js-menuSwiper не найден');
        }

        const $menuItems   = this._$menuList.querySelectorAll('.js-menuItem');
        this.menuItemCount = $menuItems.length;

        if (this._menuSwiper) {
            this._menuSwiper.destroy();
        }

        this._menuSwiper = new Swiper($menuSwiper, {
            containerModifierClass: 'Page-menu',
            wrapperClass: 'list',
            slideClass: 'item',
            slidesPerView: 'auto',
            centeredSlidesBounds: true,
            simulateTouch: true,
        });

        // data-related-id можно блоки которых нет в меню цеплять к существ блокам, например блок видео, опции и т.п. цепляем к описанию
        this._menuBlocks = getMenuBlock();

        function getMenuBlock() {
            let $menuBlocks = [...$menuItems, ...document.querySelectorAll('[data-related-id]')]
                .map($item => {
                    if ($item.dataset.relatedId) {
                        return {
                            $menu: document.querySelector(`.js-menuItem[data-href="#${$item.dataset.relatedId}"]`),
                            $block: $item,
                        }
                    }

                    let $block;
                    if ($item.dataset.href) {
                        $block = document.querySelector($item.dataset.href);
                    } else {
                        $block = document.createElement('div');
                    }

                    return {
                        $menu: $item,
                        $block: $block,
                    }
                })
                .map(item => {
                    const $parent = item.$block.offsetParent;
                    let blockHeight = height(item.$block);
                    let top = item.$block.offsetTop + menuOffset;

                    if ($parent) {
                        top += $parent.offsetTop;
                    }

                    if (item.$menu.dataset && item.$menu.dataset && item.$menu.dataset.offsetTop) {
                        top += +item.$menu.dataset.offsetTop;
                    }

                    if (item.$block.id === 'HotelMapBlock' || item.$block.id === 'Message') {
                        top += 30;
                    }

                    return Object.assign(item, {
                        top,
                        bottom: top + blockHeight,
                        height: blockHeight,
                    });
                });

            // проверка top и bottom
            // document.querySelectorAll('.js-testLine').forEach($item => $item.remove());
            // $menuBlocks.forEach($item => {
            //     let div = document.createElement('div');
            //         document.body.appendChild(div);
            //         div.setAttribute('class', 'js-testLine');
            //         div.setAttribute('style', `width: 100%;height: 3px;background-color: black;position: absolute;top: ${$item.top}px;z-index: 99999999999;`);

            //         div = document.createElement('div');
            //         document.body.appendChild(div);
            //         div.setAttribute('class', 'js-testLine');
            //         div.setAttribute('style', `width: 100%;height: 3px;background-color: black;position: absolute;top: ${$item.bottom}px;z-index: 99999999999;`);
            // });

            return $menuBlocks;
        }

        this._menuBlockIntervalId = setInterval(() => {
            this._menuBlocks = getMenuBlock();
        }, 1500);

        // нумеруем для swiper
        $menuItems.forEach(($item, i) => $item.dataset.index = i);

        let between;

        this.scrollEvent = function() {
            const scrollY = window.scrollY;
            this._menuBlocks = getMenuBlock();

            const fixed = scrollY > menuOffset;

            this._$menu.classList.toggle('is-fixed', fixed);
            this._$header.classList.toggle('is-fixed-menu', fixed);
            Layout.scroll.setTracking(this._$menu, fixed);

            // получаем ближайщий к scrollY
            const getNearest = (scrollY) => {
                let prev;
                let isBetween = false;

                // scrollY внутри блока
                this._menuBlocks.forEach((item, index) => {
                    if (item.top <= scrollY && scrollY <= item.bottom) {
                        between   = item;
                        isBetween = true;

                        // console.log(`${item.$block.getAttribute('id')} ${item.top} <= ${scrollY} && ${scrollY} <= ${item.bottom}`);
                    }

                    // scrollY вне блоков
                    if (between && between.$menu === item.$menu) {
                        if (index + 1 > this.menuItemCount - 1 || index === 0 || scrollY > item.bottom) {
                            // последний пункт меню или первый, оставляем его
                            prev = item;
                        } else {
                            // до блока, но блок не обозначен в меню
                            prev = this._menuBlocks[index - 1];
                        }
                    }
                });

                return isBetween ? between : prev;
            }
            const item = getNearest(scrollY);

            if (!item || item.$menu.parentNode.classList.contains('is-active')) {
                return false;
            }

            $menuItems.forEach($item1 => $item1.parentNode.classList.remove('is-active'));
            item.$menu.parentNode.classList.add('is-active');

            // go to specific slide
            if(this._menuSwiper) {
                this._menuSwiper.slideTo(item.$menu.dataset.index, 300, false);
            }
        }
        this.scrollEvent();

        // клик по менюшке
        $menuItems.forEach($item => $item.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            let $block = document.querySelector($item.dataset.href);
            if (!$block) {
                return;
            }

            this._menuBlocks.forEach(item => {
                if (item.$block === $block) {
                    window.scroll({
                        top: item.top,
                        behavior: 'smooth'
                    });
                }
            })
        }));

        window.addEventListener('resize', this.scrollEvent.bind(this));
        window.addEventListener('scroll', () => freeze(this.scrollEvent.bind(this), 50));
    }

    this._initLocationHash = function() {
        // при загрузке проверяем хештег и скроллим
        const hash = location.hash;
        if (hash.length > 0 && /^#[a-zA-Z]+$/.test(hash)) {
            const $menu = document.querySelector(`[data-href="${hash}"]`);

            if ($menu) {
                setTimeout(() => {
                    $menu.dispatchEvent(new Event('click'));
                }, 100);
            }
        }
    }

    // добавляем пункт в меню HTMLDomElement $item
    this.appendChild = function($item) {
        if (!$item) {
            return;
        }

        this._$menuList.appendChild($item);
        this._initNavMenu();
    }

    this.init = function() {
        this._initNavMenu();
        this._initLocationHash();
    }
    this.init();
}

export default HotelMenuNavigation;
